import {Charts} from './Charts';
import IDCRASChartsDataProvider from './contexts/IDCRASChartsDataContext'

const IDCRAS = () => {
    return (
        <IDCRASChartsDataProvider>
            <Charts />
        </IDCRASChartsDataProvider>
    );
};

export default IDCRAS;